export enum actionTypes {
    SET_IS_STICKY_FOOTER = 'SET_IS_STICKY_FOOTER',
    SET_IS_STICKY_HEADER = 'SET_IS_STICKY_HEADER',
    SET_WEB_CONTENT_LOADINGS = 'SET_WEB_CONTENT_LOADINGS',
    SET_FOOTER_CLASSNAME = 'SET_FOOTER_CLASSNAME'
}
